import { render, staticRenderFns } from "./Setup_RoutingNameEdit.vue?vue&type=template&id=259189a2&"
import script from "./Setup_RoutingNameEdit.vue?vue&type=script&lang=js&"
export * from "./Setup_RoutingNameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports